import Chatbox from '@/components/Chatbox';
import { useOutlet } from '@/context/OutletContext';

import '@/styles/index.scss';
import './ChatboxPage.scss';

export default function ChatboxPage() {
  console.log('>>> ChatboxPage');
  const { env } = useOutlet();

  return (
    <div className={`chatbox-container chatbox-container-${env} ${env === 'mobile' ? 'mobile-container' : 'web-container'}`}>
      <Chatbox />
    </div>
  );
}
